import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BTWizard = React.lazy(function () {
    return import('../../bootstrap-components/components/BTWizard');
});
var bootStrapWizard = function (props) {
    return (React.createElement(BTWizard, __assign({}, props)));
};
var Wizard = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapWizard(props);
            break;
        default:
            componentToDisplay = bootStrapWizard(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Wizard.defaultProps = {
    styleName: 'secondary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(Wizard);
//# sourceMappingURL=Wizard.js.map